import { Loader2 } from "lucide-react";
import { RefObject } from "react";

interface NotesEditorAreaProps {
  richEditorRef: RefObject<HTMLDivElement>;
  loading: boolean;
  readOnly: boolean;
  isEmpty: boolean;
  hasActiveNote: boolean;
}

export const NotesEditorArea = ({ richEditorRef, loading, readOnly, isEmpty, hasActiveNote }: NotesEditorAreaProps) => (
  <div className="relative">
    {loading && (
      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-background/50 backdrop-blur-sm z-50">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    )}

    {readOnly && isEmpty && hasActiveNote && (
      <div className="px-3 absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none z-10">
        <p className="text-sm text-muted-foreground">This note is empty</p>
      </div>
    )}
    <div ref={richEditorRef} />
  </div>
);
